import { Component, Input, OnInit } from '@angular/core';
import { MODE } from '../../shared/constant';

// Checkbox Component
@Component({
  selector: 'checkbox-component',
  styleUrls: ['./../question.scss'],
  template: `
    <div [class.has-error]="control.touched &&!control.valid && mode != 'readOnly'"
         [ngClass]="{'col-md-4 inline-padding': questiondata.params.inline == 3,'col-md-3 inline-padding': questiondata.params.inline == 4}"
         [ngClass]="{'col-md-3 inline-padding': questiondata.params.inline == 4}"
         [attr.id]="sectionId+'_'+questiondata.order+'_div'">
                    <span class="question-label" [attr.for]="sectionId+'_'+questiondata.order+'_'+option">
                        <span
                          class="asterix-space">{{(questiondata.params && questiondata.params.required == 'yes') ? '*' : ''}}</span>
                        <span
                          class="asterix-space">{{(questiondata.params.required == 'conditional' && questiondata.params.conditions[0].required == 'yes') ? '*' : ''}}</span>
                        <span [innerHTML]="questiondata.questionText"></span>
                        <help-text *ngIf="mode != 'readOnly' && questiondata.helpText"
                                   [helptext]="questiondata.helpText"></help-text>
                    </span>
      <div class="checkbox" *ngFor="let option of questiondata?.allowedOptions; let i=index">
        <label class="radio-chkbx-label"><input type="checkbox" [checked]="response.indexOf(option.value)!=-1"
                                                (change)="onChange($event,option)"
                                                [attr.name]="sectionId+'_'+questiondata.order+'_'+i"
                                                [attr.value]="option.value"
                                                [attr.id]="sectionId+'_'+questiondata.order+'_'+i"
                                                [disabled]="control.disabled"
                                                [style.width]="(!questiondata.params.inline)? questiondata.params.width + '%' : '' ">{{option.display}}
        </label>
      </div>
      <errorMessages *ngIf="mode != 'readOnly'" [control]='control' [params]='questiondata.params'
                     [isSubmitClicked]="isSubmitClicked"></errorMessages>
      <br/>
    </div><br/>
  `,
})

export class CheckboxComponent implements OnInit {
  @Input() questiondata: any;
  @Input() control: any;
  @Input() sectionId: any;
  @Input() isSubmitClicked;
  @Input() controlObject;
  @Input() mode: string;
  option: any; // TODO: this prop is being referenced on line 9, but wasn't declared; adding it here so that the compilation doesn't fail
  private response = [];

  constructor() {
  }

  ngOnInit() {
    this.init();
  }

  ngOnChanges(changes: any) {
    if (changes.mode) {
      this.init();
    }
  }

  init() {
    this.mode === MODE.READONLY ? this.control.disable(true) : this.control.enable(true);
    this.response = this.response && this.response.length > 0 ||
    (this.questiondata.iterations[0].responseText) ? this.questiondata.iterations[0].responseText.split('|') : '';
    if (this.response) {
      this.control.setValue(this.response.filter(Boolean).join('|'));
    }
  }

  onChange($event, option) {
    let value = $event.target.value;
    let chosenResponses = this.controlObject.value.iterations[0].responseMetadata['chosenResponses'];
    if ($event.target.checked) {
      if (this.questiondata.params.exclusive != null && value === this.questiondata.params.exclusive) {
        this.response = [];
        this.response[0] = value;
      } else {
        if (this.response.length === 0) this.response = [];
        (this.response[0] === this.questiondata.params.exclusive) ? this.response[0] = value : this.response.push(value);
        chosenResponses.push(option);
      }
    } else {
      this.response.splice(this.response.indexOf(value), 1);
      chosenResponses.splice(chosenResponses.indexOf(option), 1);
    }
    this.response.length === 0 ? this.control.setValue('') : this.control.setValue(this.response.filter(Boolean).join('|'));
    this.control.markAsTouched(true);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/form/controls/checkbox.component.ts